import React from 'react';

export const NoRoleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
  >
    <rect width="10" height="10" rx="5" fill="#DC3545" />
    <path
      d="M5.10906 6.74234C5.02673 6.74234 4.95706 6.71701 4.90006 6.66634C4.8494 6.60934 4.8209 6.52384 4.81456 6.40984L4.60556 2.29634C4.5929 2.12534 4.6309 1.98917 4.71956 1.88784C4.80823 1.78651 4.93806 1.73584 5.10906 1.73584C5.27373 1.73584 5.4004 1.78651 5.48906 1.88784C5.57773 1.98917 5.61573 2.12534 5.60306 2.29634L5.39406 6.40984C5.38773 6.52384 5.35923 6.60934 5.30856 6.66634C5.2579 6.71701 5.1914 6.74234 5.10906 6.74234ZM5.10906 8.53784C4.9444 8.53784 4.80823 8.48401 4.70056 8.37634C4.5929 8.26867 4.53906 8.13251 4.53906 7.96784C4.53906 7.80317 4.5929 7.67017 4.70056 7.56884C4.80823 7.46751 4.9444 7.41684 5.10906 7.41684C5.2864 7.41684 5.42256 7.46751 5.51756 7.56884C5.6189 7.67017 5.66956 7.80317 5.66956 7.96784C5.66956 8.13251 5.6189 8.26867 5.51756 8.37634C5.42256 8.48401 5.2864 8.53784 5.10906 8.53784Z"
      fill="white"
    />
  </svg>
);
